var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 66,
    viewBox: "0 0 40 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8295 65.5054H1.22031C0.531619 65.5054 0 64.9518 0 64.2899V1.21551C0.0120822 0.529531 0.567866 0 1.23239 0H37.8416C38.5303 0 39.0619 0.5536 39.0619 1.21551V64.326C39.074 64.9758 38.5182 65.5054 37.8295 65.5054Z",
    fill: "#48D38A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0787 62.7731C20.8737 62.7731 22.3289 61.3236 22.3289 59.5357C22.3289 57.7478 20.8737 56.2983 19.0787 56.2983C17.2837 56.2983 15.8286 57.7478 15.8286 59.5357C15.8286 61.3236 17.2837 62.7731 19.0787 62.7731Z",
    fill: "#41186D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3779 4.47626C35.3779 3.81434 34.8463 3.26074 34.1576 3.26074H5.11191C4.44739 3.26074 3.8916 3.79027 3.8916 4.47626V52.3025L35.3779 4.89747V4.47626Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8916 52.3035V52.4118C3.8916 53.0737 4.42322 53.6273 5.11191 53.6273H34.1697C34.8584 53.6273 35.4142 53.0737 35.39 52.3877V4.89844L3.8916 52.3035Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSms);
export default __webpack_public_path__ + "static/media/PhoneSms.78c9fb4541d4bf03c8ae2865806f49c8.svg";
export { ForwardRef as ReactComponent };